// Letzter bezahlter Klick (15.10.2026, Lückenanalyse HuTa-Ads Zeile 7). Reine Funktionen, ohne
// Browser-APIs, geprüft von scripts/check-attribution-logik.mjs.
//
// WARUM: Die UTM-Erfassung ist First-Touch (Cookie utm_params, 90 Tage, nie überschrieben). Wer
// früher eine Gassi- oder Walker-Anzeige geklickt hat und jetzt über eine HuTa-Anzeige kommt, landet
// sonst unter der alten Anzeige (Befund 14.10.: Gassi-Anzeige hängt an späteren Walker-Klicks).
// Deshalb zusätzlich ein zweiter Stand, den jeder neue bezahlte Klick überschreibt. First-Touch
// bleibt unverändert.
//
// „Bezahlt“ heißt: die Adresse trägt eine Klick-ID der Werbeplattform (gclid, gbraid, wbraid,
// gbraid, wbraid) oder ein bezahltes utm_medium. Ein fbclid allein ist NICHT bezahlt: Meta hängt
// ihn auch an organische Links aus Instagram/Facebook. Meta-Anzeigen zählen über die vereinbarte
// URL-Vorlage (utm_medium=paid_social).

export const BEZAHLTE_MEDIEN = new Set([
  "paid_social", "paid-social", "paidsocial", "cpc", "ppc", "paid", "paid_search", "display", "cpm",
]);

export interface LetzterBezahlterKlick {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_content: string | null;
  utm_term: string | null;
  /** Nur ob eine Klick-ID da war, nicht ihr Wert (der steht ohnehin in fbc bzw. gclid). */
  gclid: string | null;
  fbclid: boolean;
  /** ISO-Zeitpunkt des Klicks. */
  at: string;
  /** Pfad der Einstiegsseite dieses Klicks, ohne Query. */
  landing_page: string;
}

type Lesbar = { get(name: string): string | null };

const LAENGE = 200;

function wert(p: Lesbar, k: string): string | null {
  const v = (p.get(k) ?? "").trim();
  return v ? v.slice(0, LAENGE) : null;
}

/**
 * Liefert den neuen Stand, wenn diese Adresse ein bezahlter Klick ist, sonst null (dann bleibt
 * der gespeicherte Stand, wie er ist).
 */
export function bezahlterKlickAus(params: Lesbar, jetztIso: string, pfad: string): LetzterBezahlterKlick | null {
  const medium = (wert(params, "utm_medium") ?? "").toLowerCase();
  const gclid = wert(params, "gclid") ?? wert(params, "gbraid") ?? wert(params, "wbraid");
  const fbclid = wert(params, "fbclid");
  const bezahltesMedium = BEZAHLTE_MEDIEN.has(medium);
  if (!gclid && !bezahltesMedium) return null;
  return {
    utm_source: wert(params, "utm_source"),
    utm_medium: wert(params, "utm_medium"),
    utm_campaign: wert(params, "utm_campaign"),
    utm_content: wert(params, "utm_content"),
    utm_term: wert(params, "utm_term"),
    gclid,
    fbclid: !!fbclid,
    at: jetztIso,
    landing_page: (pfad || "/").split("?")[0].slice(0, LAENGE),
  };
}

/** Gespeicherten Stand lesen; kaputte oder fremde Werte ergeben null. */
export function letztenKlickLesen(roh: string | null | undefined): LetzterBezahlterKlick | null {
  if (!roh) return null;
  try {
    const o = JSON.parse(roh);
    if (!o || typeof o !== "object" || typeof o.at !== "string") return null;
    return o as LetzterBezahlterKlick;
  } catch {
    return null;
  }
}
